var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('router-link',{style:({ textDecoration: 'none' }),attrs:{"to":_setup.routes.login}},[_c('v-btn',{staticClass:"text-none ml-0 px-1",attrs:{"text":""}},[_c('span',{staticClass:"text-body-2 text-decoration-underline primary--text font-weight-light"},[_vm._v("Click here to login")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }